const elementInViewport = (element) =>{
    if(!(element instanceof HTMLElement)) return false;
    let bounding = element.getBoundingClientRect();
    let elementHeight = element.offsetHeight;
    let elementWidth = element.offsetWidth;

    if (bounding.top >= -elementHeight
        && bounding.left >= -elementWidth
        && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + elementWidth
        && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + elementHeight) {

        return true
    } else {

        return false
    }

}
export default elementInViewport;